'use strict';
import $ from 'jquery';
import 'slick-carousel';

export default class CTACardCarousel {
    static init() {
        $('.section-cta-card-carousel').each((index, el) => {
            new CTACardCarousel($(el));
        });
    }

    constructor($el) {
        this.el = $el;
        this.el.find('.cta-card-carousel-cards').on('init', (event, slick) => {
            this.el.find('.cta-card-carousel-card').matchHeight();
            this.el.find('.cta-card-carousel-card > div').matchHeight();
        });
        this.el.find('.cta-card-carousel-cards').on('afterChange', (event, slick, currentSlide) => {
            this.el.find('.cta-card-carousel-card').matchHeight();
            this.el.find('.cta-card-carousel-card > div').matchHeight();
        });
        this.el.find('.cta-card-carousel-cards').slick({
            mobileFirst: true,
            prevArrow: '<a class="slick-arrow slick-prev"></a>',
            nextArrow: '<a class="slick-arrow slick-next"></a>',
            responsive: [{
                breakpoint: 768,
                settings: {
                    slidesToShow: 3,
                    centerMode: true,
                    centerPadding: '150px',
                }
            }],
        });

    }
}